export enum EventTypes {
  math = 'math',
  science = 'science',
  languageArts = 'language arts',
  library = 'library',
  socialStudies = 'social studies',
  art = 'art',
  music = 'music',
  multipurpose = 'multipurpose',
  makersplace = 'makersplace',
  cafeteria = 'cafeteria',
  playground = 'playground',
  gym = 'gym',
}

export const TypesList: string[] = [
  EventTypes.math,
  EventTypes.science,
  EventTypes.languageArts,
  EventTypes.library,
  EventTypes.socialStudies,
  EventTypes.art,
  EventTypes.music,
  EventTypes.multipurpose,
  EventTypes.makersplace,
  EventTypes.cafeteria,
  EventTypes.playground,
  EventTypes.gym,
];
